export default __webpack_public_path__ + "static/project-slide-6-1640-765-03554262b72954c3607cb60bce6e26fe.jpg";